import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {ISiteCreditBalanceIncoming} from "../../../models/site/credit/ISiteCreditBalanceIncoming";
import {ISiteCreditTransactionIncoming} from "../../../models/site/credit/ISiteCreditTransactionIncoming";
import {ISiteCreditPurchaseOutgoing} from "../../../models/site/credit/ISiteCreditPurchaseOutgoing";
import {ISiteCreditPurchaseIncoming} from "../../../models/site/credit/ISiteCreditPurchaseIncoming";
import {INetworkComponent} from "../../../network/types/INetworkComponent";

export class SiteCreditService {

    public static async purchase(data: ISiteCreditPurchaseOutgoing, component?: INetworkComponent): Promise<ISiteCreditPurchaseIncoming> {
        let request = await Network.postJson(ProductType.PANEL, `/site/credit/purchase`, data, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getBalance(component?: INetworkComponent): Promise<ISiteCreditBalanceIncoming> {
        let request = await Network.get(ProductType.PANEL, `/site/credit/balance`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async findAll(component?: INetworkComponent): Promise<ISiteCreditTransactionIncoming[]> {
        let request = await Network.get(ProductType.PANEL, `/site/credit/transactions`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }
}
